import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'services/auth/auth.service';
import { User } from 'domain-models/User';
import { UserCredentials } from 'domain-models/UserCredentials';
//import { Crypto } from 'libraries/Crypto'
import { NoTokenError } from 'app/common/no-token-error';
import { AppError } from 'app/common/app-error';
import { Helper } from 'libraries/Helper';
import { environment } from 'environments/environment';
import swal from 'sweetalert2';
declare var msal: any; //this is set from the CDN

@Component({
	selector: 'login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css']
})

/**
 * Component for user login
 */
export class LoginComponent implements OnInit {
	ngOnInit(): void {
		//this.authService.logout();
	}
	ttoken: any;
	invalidLogin: boolean;
	validBrowser: boolean = true;
	trustBrowser: boolean = true;
	loading: boolean = false;
	ssoLoginPending: boolean = false;
	ssoLoginResponse: any = null;
	username: string;
	password: string;
	msalInstance = new msal.PublicClientApplication(environment.azureAD.msalConfig); //instantiate msal
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private authService: AuthService
	) {}

	async ssoLogin() {
		this.ssoLoginPending = true;
		try {
			this.ssoLoginResponse = await this.msalInstance.loginPopup(environment.azureAD.loginRequest);
			// console.log(loginResponse)
			let result = await this.authService.ssoLogin(this.ssoLoginResponse.accessToken);
			let returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
			this.router.navigate([returnUrl || '/']);
		} catch (error) {
			if (error instanceof NoTokenError && this.ssoLoginResponse) {
				try {
					let result = await this.authService.sendValidationCodeAsync({
						access_token: this.ssoLoginResponse.accessToken
					});
					this.validBrowser = false;
					let email: string = result as any;
					var arr = email.split('@');
					email =
						email.substr(0, arr[0].length * 0.3) +
						'*******' +
						email.substr(arr[0].length - 1, 1) +
						'@' +
						arr[1];
					Helper.alert(
						'We do not recognize this browser, we have sent you an email to ' +
							email +
							' with a code you need to enter to validate is you.',
						1
					);
					this.loading = false;
				} catch (e) {
					console.log(error);
					Helper.alert('Please try again in a few minutes', 1);
					this.loading = false;
				}
				this.loading = false;
			} else {
				this.ssoLoginPending = false;
				if (error.originalError && error.originalError.message) {
					Helper.alert(error.originalError.message, 1);
					this.loading = false;
				} else if (error.errorMessage) {
					Helper.alert(error.errorMessage, 1);
					this.loading = false;
				} else {
					Helper.alert('Server not available. Contact administrator.', 1);
					this.loading = false;
				}
			}
		}
	}

	/**Function that performs the login of the user using AuthServices */
	signIn(formCredentials: UserCredentials) {
		if (this.ssoLoginPending) {
			this.authService
				.getBrowserTokenForSSO(
					this.ssoLoginResponse.accessToken,
					formCredentials.token,
					this.trustBrowser
				)
				.subscribe(
					async (res) => {
						var token = res.token;
						try {
							let result = await this.authService.ssoLogin(
								this.ssoLoginResponse.accessToken,
								token
							);
							if (result) {
								let returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
								this.router.navigate([returnUrl || '/']);
							} else {
								this.invalidLogin = true;
							}
							this.loading = false;
						} catch (e) {
							(error: AppError) => {
								Helper.alert('User blocked!', 1);
								this.loading = false;
							};
						}
					},
					(error: AppError) => {
						console.log(error);
						Helper.alert(error.originalError.message);
						this.loading = false;
					}
				);
			return;
		}
		if (!this.username || !this.password) {
			Helper.alert('Please enter username and password!', 1);
			return;
		}

		this.loading = true;

		var credentials: UserCredentials = new UserCredentials();
		credentials.username = this.username;
		credentials.password = this.password;
		credentials.token = this.ttoken;
		var salt: string = '';

		if (this.validBrowser === true) {
			//maybe actually check for localStorage to see if if its valid
			// this.authService.getSalt(credentials.username)
			//   .subscribe(result => {
			//     salt = result.Salt;
			//     credentials.password = Crypto.HashWithBase64Salt(credentials.password, salt);

			this.authService.login(credentials).subscribe(
				(result) => {
					if (result) {
						let returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
						this.router.navigate([returnUrl || '/']);
					} else {
						//this.invalidLogin = true;
						Helper.alert('Invalid username and/or password.', 1);
					}
					this.loading = false;
				},
				(error: AppError) => {
					if (error instanceof NoTokenError) {
						this.authService.sendValidationCode(credentials).subscribe(
							(result) => {
								this.validBrowser = false;
								var email: string = result;
								var arr = email.split('@');
								email =
									email.substr(0, arr[0].length * 0.3) +
									'*******' +
									email.substr(arr[0].length - 1, 1) +
									'@' +
									arr[1];
								Helper.alert(
									'We do not recognize this browser, we have sent you an email to ' +
										email +
										' with a code you need to enter to validate is you.',
									1
								);
								this.loading = false;
							},
							(error: AppError) => {
								console.log(error);
								Helper.alert('Please try again in a few minutes', 1);
								this.loading = false;
							}
						);

						this.loading = false;
					} else {
						//Helper.alert("Invalid username and/or password.",1);
						if (error.originalError.message) {
							Helper.alert(error.originalError.message, 1);
							this.loading = false;
						} else {
							Helper.alert('Server not available. Contact administrator.', 1);
							this.loading = false;
						}
					}
				}
			);
			// }
			// ,
			// (error: AppError) => {
			//   Helper.alert(error.originalError.message, 1);
			//   this.loading = false;
			// });
		} else {
			// this.authService.getSalt(credentials.username)
			//   .subscribe(result => {
			//     salt = result.Salt;
			//     credentials.password = Crypto.HashWithBase64Salt(credentials.password, salt);
			this.authService.getBrowserToken(credentials, this.trustBrowser).subscribe(
				(result) => {
					var token = result.token;
					this.authService.login(credentials, token).subscribe(
						(result) => {
							if (result) {
								let returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
								this.router.navigate([returnUrl || '/']);
							} else {
								this.invalidLogin = true;
							}
							this.loading = false;
						},
						(error: AppError) => {
							Helper.alert('User blocked!', 1);
							this.loading = false;
						}
					);
				},
				(error: AppError) => {
					console.log(error);
					Helper.alert(error.originalError.message);
					this.loading = false;
				}
			);

			// },
			// (error: AppError) => {
			//   Helper.alert(error.originalError.message, 1);
			//   this.loading = false;
			// });
		}
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/login/login.component.ts